module.exports = __webpack_public_path__ + "img/Icon-icons.65ee1bb0.svg";